<template>
  <v-row align="center" justify="center" class="mt-n8 mb-4">
    <v-col cols="12" align="center" justify="center">
      <div class="d-flex justify-center">
        <v-select
          v-model="selectedEndTypes"
          class="mr-4 mw-150"
          label="End Type"
          multiple
          :items="[
            { value: 'NO_TRANSITION', text: 'No transition' },
            { value: 'CONTINUED', text: 'Continued' },
            { value: 'RETURNED', text: 'Returned' },
          ]"
          @input="$emit('endtypes', selectedEndTypes)"
        />
        <v-select
          v-model="selectedTransitionProductTypes"
          class="mr-4 mw-150"
          label="End Transition Product Type"
          multiple
          :items="[
            { value: 'NO_CHANGE', text: 'No Change' },
            { value: 'UPGRADING', text: 'Upgrading' },
            { value: 'DOWNGRADING', text: 'Downgrading' },
          ]"
          @input="$emit('transitionproducttypes', selectedTransitionProductTypes)"
        />
        <v-select
          v-model="selectedCorporateType"
          class="mr-4 mw-150"
          label="Corporate"
          :items="[
            { value: 'CORPORATE', text: 'Corporate' },
            { value: 'CUSTOMER', text: 'Customer' },
          ]"
          @input="$emit('corporatetypes', selectedCorporateType)"
        />
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "SurveyResultFilters",
  data() {
    return {
      selectedCorporateType: "CUSTOMER",
      selectedEndTypes: null,
      selectedTransitionProductTypes: null,
    };
  },
};
</script>
<style scoped>
.mw-150 {
  max-width: 150px;
}
</style>
